<template>
  <div class="main">
    <div class="container">
      <router-link to="/">
        <div class="logo">
          <img alt="logo" src="@/assets/logo.png" />
          <div class="title2">
            <span>KoLA Benchmark</span>
          </div>
        </div>
      </router-link>
      <div class="routerBtn">
        <!-- 排行榜下拉 -->
        <div
          class="nav-dropdown"
          @mouseenter="showDropdown = true"
          @mouseleave="showDropdown = false"
          :class="{ active: $route.fullPath === '/LeaderBoard' || $route.fullPath.startsWith('/cke/') }"
        >
          <a class="dropdown-trigger">
            LEADERBOARD
            <span class="dropdown-arrow">▾</span>
          </a>
          <div class="dropdown-menu" v-show="showDropdown">
            <router-link to="/LeaderBoard" class="dropdown-item" @click.native="showDropdown = false">Internal Knowledge</router-link>
            <a href="/cke/index.html" class="dropdown-item">External Knowledge</a>
          </div>
        </div>
        <!-- 常规导航项 -->
        <div
          v-for="item in routerList"
          :key="item.url"
          :class="{ active: !item.external && $route.fullPath === item.url }"
          @click="routerBtnClick(item)"
        >
          <router-link v-if="!item.external" :to="item.url">{{ item.name }}</router-link>
          <a v-else :href="item.url" class="ext-link">{{ item.name }}</a>
        </div>
        <div
          v-if="isLogin"
          :class="{ active: $route.fullPath === '/profile' }"
          @click="routerBtnClick('/profile')"
        >
          <router-link to="/profile"> PROFILE </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getUserProfile } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  data() {
    return {
      routerList: [
        { name: 'TASKS', url: '/Tasks' },
        { name: 'ABOUT US', url: '/AboutUs' },
        { name: 'SUBMIT', url: '/Submit' }
      ],
      isLogin: false,
      showDropdown: false
    }
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search)
    const token = getToken()
    if (token) {
      console.log('有token直接登录')
      this.getUserInfo()
      this.isLogin = true
    } else {
      console.log('无token调用登录')
      const code = urlParams.get('code')
      if (code) {
        login({ code }).then(res => {
          setToken(res.data)
          this.$notify({ title: '登录成功', duration: 1000 })
          this.getUserInfo()
          this.isLogin = true
        })
      }
    }
  },
  methods: {
    getUserInfo() {
      getUserProfile().then(res => {
        console.log(res)
      })
    },
    userLogin() {
      if (this.isLogin) {
        removeToken()
        this.isLogin = false
      } else {
        window.location.href =
          'https://github.com/login/oauth/authorize?client_id=10e44a6a4de0cbd5e9a0'
      }
    },
    routerBtnClick() {
      console.log(this.$route)
    }
  },
  watch: {
    isLogin(val) {}
  }
}
</script>

<style scoped>
.main {
  padding-top: 2.66667rem;
  width: 100%;
  min-width: 82.13333rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main .container {
  display: flex;
  width: 82.13333rem;
  justify-content: space-between;
}
.main .container .logo {
  display: flex;
}
.main .container .logo img {
  width: 3.4rem;
  height: 3.4rem;
}
.main .container .logo .title2 {
  width: 14rem;
  height: 1.86667rem;
  font-size: 1.6rem;
  margin-left: 0.4rem;
  font-family: InstrumentSans-SemiBold !important;
  font-weight: 600;
  color: #000;
  line-height: 3.4rem;
}
.main .container .logo .title2 span {
  font-family: InstrumentSans-SemiBold !important;
}
.main .container .routerBtn {
  padding: 0 1.33333rem;
  display: flex;
  min-width: 40.53333rem;
  height: 3rem;
  color: #000;
  border-radius: 2rem;
  justify-content: space-around;
  opacity: 1;
  border: 0.13333rem solid #000;
}
.main .container .routerBtn .router-link-active,
.main .container .routerBtn div.active a.ext-link {
  font-family: InstrumentSans-MediumItalic, InstrumentSans;
  font-weight: 400;
  color: #6a3278;
}
.main .container .routerBtn div a {
  font-size: 1.06667rem;
  height: 1.46667rem;
  font-family: InstrumentSans-Medium, InstrumentSans;
  font-weight: 500;
  color: #000;
  line-height: 3rem;
}
/* 下拉菜单 */
.main .container .routerBtn .nav-dropdown {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 3rem;
}
.main .container .routerBtn .nav-dropdown .dropdown-trigger {
  font-size: 1.06667rem;
  font-family: InstrumentSans-Medium, InstrumentSans;
  font-weight: 500;
  color: #000;
  line-height: 3rem;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  text-decoration: none;
}
.main .container .routerBtn .nav-dropdown.active .dropdown-trigger {
  font-family: InstrumentSans-MediumItalic, InstrumentSans;
  font-weight: 400;
  color: #6a3278;
}
.main .container .routerBtn .nav-dropdown .dropdown-arrow {
  font-size: 0.8rem;
  transition: transform 0.2s;
}
.main .container .routerBtn .nav-dropdown:hover .dropdown-arrow {
  transform: rotate(180deg);
}
.main .container .routerBtn .nav-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 0.1rem solid #000;
  border-radius: 0.5rem;
  min-width: 7rem;
  z-index: 999;
  overflow: hidden;
  box-shadow: 0 0.3rem 0.8rem rgba(0,0,0,0.12);
  margin-top: -0.1rem;
}
.main .container .routerBtn .nav-dropdown .dropdown-menu .dropdown-item {
  display: block;
  padding: 0.5rem 1.2rem;
  font-size: 0.93rem;
  font-family: InstrumentSans-Medium, InstrumentSans;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  text-align: center;
  white-space: nowrap;
  line-height: 1.6;
  transition: background 0.15s, color 0.15s;
}
.main .container .routerBtn .nav-dropdown .dropdown-menu .dropdown-item:hover {
  background: #f3ecf5;
  color: #6a3278;
}
.main .container .routerBtn .nav-dropdown .dropdown-menu .dropdown-item + .dropdown-item {
  border-top: 0.06667rem solid #e0d4e4;
}
.main .container .login {
  width: 6.93333rem;
  height: 3rem;
  background: #000;
  border-radius: 2rem;
  opacity: 1;
}
.main .container .login:hover {
  cursor: pointer;
}
</style>
